<template>
  <div>
    <h1 class="title">{{ $t("season-season-name", [season.name]) }}</h1>
    <br />
    <div class="columns">
      <div class="column">
        <router-link
          v-for="division in season.divisions"
          :to="`/divisions/${division.name.toLowerCase()}`"
          :key="division.id"
        >
          <span class="title is-5">{{ division.name }} </span>
          <router-link v-for="team in division.teams" :to="`/teams/${team.id}`" :key="team.id">
            <p>{{ team.name }}</p>
          </router-link>
          <br />
        </router-link>
        <br />
        <router-link class="button" :to="`${season.id}/divisions/new`">
          {{ $t("new-division") }}
        </router-link>
      </div>
      <div class="column">
        <span class="title is-5">{{ $t("AppMenu.people") }}</span>
        <router-link v-for="person in season.people" :to="`/people/${person.id}`" :key="person.id">
          <p>{{ person.first }} {{ person.last }}</p>
        </router-link>
        <br />
        <router-link class="button" :to="`${season.id}/people/new`">
          {{ $t("PersonForm.new-person") }}
        </router-link>
      </div>
      <div class="column">
        <span class="title is-5">{{ $t("AppMenu.venues") }}</span>
        <router-link v-for="venue in season.venues" :to="`/venues/${venue.id}`" :key="venue.id">
          <p>{{ venue.name }}</p>
        </router-link>
        <br />
        <router-link class="button" :to="`${season.id}/venues/new`">
          {{ $t("AppMenu.new_venue") }}
        </router-link>
      </div>
    </div>
    <router-view></router-view>
    <br /><br />
    <!-- {{ season }} -->
  </div>
</template>

<script>
import api from "@/api";
export default {
  components: {},
  data() {
    return {
      season: {},
      isLoading: true,
    };
  },

  methods: {
    fetchData() {
      api.getSeason(this.$route.params.season_id).then(response => {
        this.season = response.data;
        this.isLoading = false;
      });
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    "$route.params.season_id": function(id) {
      this.fetchData();
      window.analytics.page();
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss"></style>
